import styled from 'styled-components'
import { useEffect, useState, useRef } from 'react'
import _ from 'lodash'
import { useBreakpoint } from '../config/theme/media'

const StyledStickyHeader = styled.div`
  background-color: white;
  width: 100%;

  ${props => props.isSticky &&
    `
      position: sticky;
      top: 0;
      z-index: 10;
      transition: all 0.5s ease;
      animation: smoothScroll 1s forwards;
    `
  }
`

const StickyHeader = (props) => {
  const { children, disableInMobile } = props

  
  const [sticky, setSticky] = useState(false)
  const headerRef = useRef(null)
  const { lt } = useBreakpoint()
  
  const handleScroll = (elTopOffset, elHeight) => {
    if (disableInMobile && lt('md')) {
      return setSticky(false)
    }

    if (window.pageYOffset > (elTopOffset + elHeight)) {
      return setSticky(true)
    } else {
      return setSticky(false)
    }
  };

  useEffect(() => {
    var header = headerRef.current.getBoundingClientRect()
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height)
    }

    window.addEventListener('scroll', handleScrollEvent);

    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, [lt]);
  

  return <StyledStickyHeader ref={headerRef} isSticky={sticky}>{children}</StyledStickyHeader>
}

export default StickyHeader
